<template>
  <div class="dqyxfx-warp">
    <resize-container :tabShow="tabShow">
      <div class="left-content" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick" @changeCompany="changeCompany"></tab-tree>
      </div>
      <div class="right-content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="dn-content-bg box1 zt">
          <time-search ref="timeSearch" :control="{data:timeData}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick">
          </time-search>
        </div>
        <div class="tab-pane ">
          <div class="tab-title dn-title-bg">
            <span :class="activecode=='perCapita'?'btn btnactive dn-title-bg':'btn dn-title-bg'" @click="both('perCapita')">人均</span>
            <span :class="activecode=='surfaceAre'?'btn btnactive dn-title-bg':'btn dn-title-bg'" @click="both('surfaceAre')">面均</span>
          </div>
          <div class="tap-echarts dn-content-bg">
            <div class="echarts">
              <echarts :echartsData="echartsData"></echarts>
            </div>
          </div>
          <div class="tables table-content dn-content-bg">
            <nk-table id="table" :data="tableData" :noDataTitle="'该时间段暂无数据'" :columns="columns" :border="false" :rowselect="true">
            </nk-table>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import { findDataByParam } from '@/utils/index.js'
import * as utils from '@/utils/index.js'
import echarts from './pages/echarts.vue'
import TimeSearch from '@/components/common/TimeSearch.vue'
import TabTree from '@/components/common/TabTree.vue'
import dateTool from '@/utils/dateTool'
import NkTable from '@/components/common/NkTable'
import BtnShow from '@/components/common/BtnShow.vue'
import ResizeContainer from '@/components/common/resizeContainer.vue'
let allTimeData = [
  {
    type: 'day',
    label: '日',
  },
  {
    type: 'month',
    label: '月',
  },
  //   {
  //     type: "year",
  //     label: "年",
  //   },
]
export default {
  components: {
    TimeSearch,
    TabTree,
    echarts,
    NkTable,
    BtnShow,
    ResizeContainer,
  },
  data () {
    return {
      tabShow: true,
      viewTreeData: [],
      timeData: allTimeData,
      columns: [],
      tableData: [],
      chartData: [],
      selectedDate: {},
      echartsData: {},
      activecode: 'perCapita',
      pointInfo: {
        pointCode: '100229',
        pointNumber: '0',
      },
      unit: 'kWh/人',
    }
  },
  created () { },
  activated () { },
  methods: {
    changeCompany (companyId) {
      let vm = this
      vm.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, '/nygl/comparedAnalysis', null)
        .then((res) => {
          if (res) {
            const viewTreeData = findDataByParam('viewTree', true, res.data)
            vm.viewTreeData = viewTreeData
          }
        })
    },
    /* 树加载 */
    tabTreeDefault (e) {
      this.selectNodes = e
      let time = new Date()
      let startTime = dateTool.format(time, 'yyyy-MM-dd ') + '00:00:00'
      time.setDate(time.getDate() + 1)
      let endTime = dateTool.format(time, 'yyyy-MM-dd') + ' 00:00:00'
      this.selectedDate = {
        dataType: '1',
        dateType: 'day',
        startTime: startTime,
        endTime: endTime,
      }
      this.TimeControlClick(this.selectedDate)
    },
    /* 树点击 */
    tabTreeClick (e) {
      this.selectNodes = e
      this.TimeControlClick(this.selectedDate)
    },
    /* 树复选框勾选事件 selectNodeAr所有选中的点 */
    changeTree (selectNodeIdArr, ids, selectNodeAr) { },
    /* 人均面均选择  */
    both (type) {
      this.activecode = type
      this.TimeControlClick(this.selectedDate)
    },
    timeControlChange () { },
    /* 查询 */
    TimeControlClick (e) {
      this.selectedDate = e
      this.getData()
    },

    async getData () {
      let vm = this
      let measureId = vm.selectNodes.measureId
      let pointCode = vm.pointInfo.pointCode
      let pointNumber = vm.pointInfo.pointNumber
      let res = null
      let cycle = null /* 时间数据类型 */
      let dateType = vm.selectedDate.dateType
      if (dateType == 'day') {
        cycle = 'hour'
      } else if (dateType == 'month') {
        cycle = 'day'
      } else if (dateType == 'year') {
        cycle = 'month'
      }
      if (vm.activecode == 'perCapita') {
        /* 人均 */
        res = await vm.$api.tmp.getCapitaConsume(
          measureId,
          pointCode,
          pointNumber,
          vm.selectedDate.startTime,
          vm.selectedDate.endTime,
          0,
          cycle
        )
        this.unit = 'kWh/人'
      } else {
        /* 面均 */
        res = await vm.$api.tmp.getAreaConsume(
          measureId,
          pointCode,
          pointNumber,
          vm.selectedDate.startTime,
          vm.selectedDate.endTime,
          0,
          cycle
        )
        this.unit = 'kWh/m²'
      }
      let legend = ['本期', '同期']
      let obj = {
        legend: legend,
        xData: res.data.x,
        unit: this.unit,
        series: [
          {
            data: res.data.y[0],
            type: 'bar',
            name: legend[0],
          },
          {
            data: res.data.y[1],
            type: 'bar',
            name: legend[1],
          },
        ],
      }
      this.echartsData = obj
      let columns = [
        {
          prop: 'currentTime',
          label: '本期时间',
          show: true,
          align: 'left',
        },
        {
          prop: 'currentValue',
          label: '本期能耗',
          show: true,
          align: 'center',
        },
        {
          prop: 'prevTime',
          label: '同比日期',
          show: true,
          align: 'center',
        },
        {
          prop: 'prevValue',
          label: '同比能耗',
          show: true,
          align: 'center',
        },
        {
          prop: 'difference',
          label: '增减量',
          show: true,
          align: 'center',
        },
        {
          prop: 'trend',
          label: '同比趋势(%)',
          show: true,
          align: 'center',
        },
      ]
      this.columns = columns
      let tableData = res.data.table
      this.tableData = tableData
    },
  },
}
</script>
<style  scoped lang="scss">
.dqyxfx-warp {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  overflow: hidden;
}
.left-content {
  //   width: 260px;
  height: 100%;
  min-width: 200px;
  margin-right: 14px;
}
.right-content {
  height: 100%;
  position: relative;
  overflow: auto;
  display: flex;
  flex-flow: column;
}
.box1 {
  padding: 5px;
  box-sizing: border-box;
  color: #2e3842;
  margin-bottom: 14px;
}
.tab-pane {
  width: 100%;
  height: calc(100% - 74px);
  border-radius: 4px;
  .tab-title {
    height: 38px;
    line-height: 38px;
    text-align: left;
    font-size: 17px;
  }
  .tap-echarts {
    height: 66%;
    margin-bottom: 14px;
    .tab-top {
      height: 45px;
      line-height: 45px;
      padding: 0 14px;
      box-sizing: border-box;
      text-align: left;
      color: #fff;
      font-size: 20px;
      border-radius: 4px 4px 0px 0px;
    }
    .echarts {
      height: 100%;
      width: 100%;
    }
  }
  .tables {
    height: calc(34% - 52px);
    // height: calc( 34% - 14px);
    width: 100%;
  }
}
.flex {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex1 {
  flex: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.big {
  color: #bc635e;
}
.small {
  color: #7fad7d;
}
.btn {
  display: inline-block;
  padding: 0 0.9rem;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  font-size: 0.7rem;
  cursor: pointer;
  outline: none;
  font-weight: bold;
  height: 38px;
  line-height: 40px;
}
.btnactive {
  color: #0197ee !important;
}
</style>